import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  Input,
  Form,
  Button // Button import edildi
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";

import { Name, Date } from "./contactlistCol";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";

import {
  addDynamicForm as onaddDynamicForm,
  updateDynamicForm as onUpdateDynamicForm,
  deleteDynamicForm as onDeleteDynamicForm,
  getDynamicForm as onGetDynamicForm ,
} from "store/contacts/actions";
import { isEmpty } from "lodash";
import moment from "moment";
import TableContainer from "../../../components/Common/TableContainer";

import { useSelector, useDispatch } from "react-redux";
import { NameSurname } from "../Users/contactlistCol";

// PDF Kütüphaneleri
import jsPDF from "jspdf";
import "jspdf-autotable";

const ContactsList = props => {

  //meta title
  document.title = " Satın Alımlar | BeeEducation ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [getEdit, setEdit] = useState();

  // validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: (getEdit && getEdit.Dynamic_Form_Name) || "",
      startAge: (getEdit && getEdit.Dynamic_Form_StartAge) || "",
      finishAge: (getEdit && getEdit.Dynamic_Form_FinishAge) || '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Lütfen Adınızı Giriniz"),
      startAge: Yup.string().required("Başlangıç Yaşınızı Giriniz"),
      finishAge: Yup.string().required("Bitiş Yaşınızı Giriniz")
    }),
    onSubmit: values => {
      var localDate = moment().local();
      if (isEdit) {
        const updateUser = {
          ID: getEdit.ID,
          Dynamic_Form_Name:values.name,
          Dynamic_Form_StartAge: values.startAge,
          Dynamic_Form_FinishAge: values.finishAge,
          Dynamic_Form_IsActive: getActive
        };
        dispatch(onUpdateDynamicForm(updateUser));
        setIsEdit(false);
        validation.resetForm();
      } else {
        const newUser = {
          Dynamic_Form_Name:values["name"],
          Dynamic_Form_StartAge: values["startAge"],
          Dynamic_Form_FinishAge: values["finishAge"],
          Dynamic_Form_IsActive: getActive,
          Dynamic_Form_CreatedDateTime: localDate
        };
        dispatch(onaddDynamicForm(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.dynamic,
  }));
  
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [getActive, setActive] = useState(false);

  // --- PDF EXPORT FONKSİYONU ---
  const exportPDF = () => {
    const unit = "pt";
    const size = "A4"; 
    const orientation = "landscape"; // Tablo geniş olduğu için yatay

    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);
    doc.text("Satın Alımlar Listesi", 40, 40);

    const headers = [[
      "Ürün Adı",
      "Ücret",
      "Satın Alma Tarihi",
      "Bitiş Süresi",
      "Kullanıcı"
    ]];

    const data = users.map(item => {
        // Kullanıcı Adı Mantığı (Tablodaki logic ile aynı)
        let userName = item.DeviceId; // Varsayılan Device ID
        if (item.Users && item.Users.Users_NameSurname) {
            userName = item.Users.Users_NameSurname;
        }

        return [
            item.BasePlanId || "-",
            item.DisplayPrice || "-",
            item.CreatedAt ? moment(item.CreatedAt).format('DD.MM.YYYY HH:mm') : "-",
            item.ExpiryTime ? moment(item.ExpiryTime).format('DD.MM.YYYY HH:mm') : "-",
            userName
        ];
    });

    doc.autoTable({
      startY: 50,
      head: headers,
      body: data,
      theme: 'grid', 
      styles: { fontSize: 10, cellPadding: 3 },
    });

    doc.save("Satin_Alimlar.pdf");
  };
  // -----------------------------

  const handleUserClicks = () => {
    setIsEdit(false);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
      {
        Header: 'Ürün Adı',
        accessor: 'BasePlanId',
        filterable: true,
        disableFilters: true,
        Cell: (cellProps) => {
          return <Name {...cellProps} />;
        }
      },
       {
        Header: 'Ücret',
        accessor: 'DisplayPrice',
        filterable: true,
        disableFilters: true,
        Cell: (cellProps) => {
          return <Name {...cellProps} />;
        }
      },
      {
        Header: 'Satın Alma Tarihi',
        accessor: 'CreatedAt',
        filterable: true,
        disableFilters: true,
        Cell: (cellProps) => {
          return <Date {...cellProps} />;
        }
      },
      {
        Header: 'Bitiş Süresi',
        accessor: 'ExpiryTime',
        filterable: true,
        disableFilters: true,
        Cell: (cellProps) => {
          return <Date {...cellProps} />;
        }
      },
       {
        Header: "Kullanıcı",
        accessor: "Users.Users_NameSurname", 
        filterable: true,
        disableFilters: true,
        Cell: cellProps => {
          const rowData = cellProps.row.original;
          if (!rowData.UsersId) {
            return <>{rowData.DeviceId}</>;
          } else {
            return <NameSurname {...cellProps} />;
          }
        },
      },
    ],
    []
  );

  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetDynamicForm());
    }
  }, [dispatch, users]);

  useEffect(() => {
    setContact(users);
    setIsEdit(false);
  }, [users]);

  useEffect(() => {
    if (!isEmpty(users) && !!isEdit) {
      setContact(users);
      setIsEdit(false);
    }
  }, [users]);

  const toggle = () => {
    setModal(!modal);
  };

  const handleUserClick = arg => {
    const user = arg;
    setContact(user);
    setIsEdit(true);
    setActive(user.Dynamic_Form_IsActive)
    setEdit(user)
    toggle();
  };

  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  const [deleteModal, setDeleteModal] = useState(false);

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteDynamicForm(contact.ID));
    }
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  return (
    <React.Fragment>
    <DeleteModal
      show={deleteModal}
      onDeleteClick={handleDeleteUser}
      onCloseClick={() => setDeleteModal(false)}
    />
    <div className="page-content">
      <Container fluid>
        {/* Render Breadcrumbs */}
        <Breadcrumbs title="Yönetim" breadcrumbItem="Satın Alma" />
        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                
                {/* PDF BUTONU EKLEME ALANI */}
                <div className="d-flex justify-content-end mb-3">
                   <Button 
                      color="danger" 
                      className="btn-rounded" 
                      onClick={exportPDF}
                   >
                      <i className="mdi mdi-file-pdf-box me-1"></i> PDF Olarak İndir
                   </Button>
                </div>

                <TableContainer
                  columns={columns}
                  data={users}
                  isGlobalFilter={true}
                  isAddAuthList={false}
                  handleUserClick={handleUserClicks}
                  customPageSize={10}
                  className="custom-header-css"
                />

                <Modal isOpen={modal} toggle={toggle}>
                  <ModalHeader toggle={toggle} tag="h4">
                    {!!isEdit ? "Düzenle" : "Üye Ekle"}
                  </ModalHeader>
                  <ModalBody>
                    <Form
                      onSubmit={e => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <Row>
                        <Col xs={12}>
                          <div className="mb-3">
                            <Label className="form-label">Rol Adı</Label>
                            <Input
                              name="authName"
                              label="Rol Adı"
                              type="text"
                              placeholder="Rol Adını Giriniz"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.authName || ""}
                              invalid={
                                validation.touched.authName &&
                                  validation.errors.authName
                                  ? true
                                  : false
                              }
                            />
                             {validation.touched.authName &&
                              validation.errors.authName ? (
                              <FormFeedback type="invalid">
                                {validation.errors.authName}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <div className="text-end">
                            <button
                              type="submit"
                              className="btn btn-success save-user"
                            >
                              Kaydet
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </ModalBody>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  </React.Fragment>
  );
};

export default withRouter(ContactsList);